import "../pages/CheckIn.css";
import { React, useState, useEffect, useRef, Component ,useImperativeHandle, forwardRef} from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { apiMain } from "../../App";
import { useSnackbar } from "notistack";
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Messages } from "../data/Messages";
const columns = [
    // { field: 'Id', headerName: 'ID', width: 90 },
    { field: 'Rtype_Id', headerName: 'Id', width: 15,editable: false, },
    {
        field: 'Rtype_Name',
        headerName: 'Type',
        width: 110,
        editable: true,
    },


];
const paginationModel = { page: 0, pageSize: 5 };
const Room_Types =forwardRef((props,ref)=>{
    const [Rtype_Name, setRtype_Name] = useState('');
    const [Rtype_Id, setRtype_Id] = useState('');
    const [Data, setData] = useState([]);
    const [Addflag,setAddflag]=useState(false);
    const [EditFlag,setEditFlag]=useState(false);
    const [DelFlag,setDelFlag]=useState(false);
    const [NewFlag,setNewFlag]=useState(true);
    const [error, setError] = useState(false);
    const [alertType , setalertType]=useState(0);
    const [txtMessage , settxtMessage]=useState("");
    const { enqueueSnackbar } = useSnackbar();
    const [dialogError, setDialogError] = useState({});
    const [dialogLoading, setDialogLoading] = useState(false);
    useImperativeHandle(ref, () => ({
        add: sendAdd,
        edit: sendUpdate,
        del: sendDelete,
        new: onNewAgency,
      }));
    const ODD_OPACITY = 0.2;
    useEffect(() => {
        setAddflag(props.permission[5].Per_Add)
        setEditFlag(props.permission[5].Per_Edit)
        setDelFlag(props.permission[5].Per_Del)
        getData();
    }, [])
    const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
        [`& .${gridClasses.row}.even`]: {
            backgroundColor: theme.palette.grey[200],
            '&:hover': {
                backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
            '&.Mui-selected': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY + theme.palette.action.selectedOpacity,
                ),
                '&:hover': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY +
                        theme.palette.action.selectedOpacity +
                        theme.palette.action.hoverOpacity,
                    ),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: alpha(
                            theme.palette.primary.main,
                            ODD_OPACITY + theme.palette.action.selectedOpacity,
                        ),
                    },
                },
            },
        },
    }));


    const getData = async () => {
        // let uparams = new URLSearchParams();
        // uparams.append("Reserv_Id", localStorage.getItem('Reserv_Id'));
        let res = await GetDataPromise(`${apiMain}/api/v1/roomtype`, true);

        let parsed = JSON.parse(res);
        console.log(parsed)
        if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
            let newData = parsed.data;
            setData(newData)

        }
    }
    const sendAdd = async (e) => {
        let formdata = new FormData();
        formdata.append("Rtype_Id", Rtype_Id);
        formdata.append("Rtype_Name", Rtype_Name);
        let response;
    
             response = await PostDataPromise(apiMain + "/api/v1/roomtype/insert", formdata);
            let parsed = JSON.parse(response);
             getData()
         cleardata();
  }
  const sendDelete = async (e) => {
    let formdata = new FormData();
      formdata.append("Rtype_Id", Rtype_Id);
     let response;
    //  setDialogLoading(true);
    if(Rtype_Id > 0){
          response = await PostDataPromise(apiMain + "/api/v1/roomtype/delete", formdata);
     } 
     setDialogLoading(false);
    let parsed = JSON.parse(response);
    if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
        // okay
        enqueueSnackbar(Messages.success, { variant: 'success' });
        setalertType(1)
        settxtMessage("Data deleted successfully.")
        setError(true);
          // props.save()
    } else {
        if(parsed.data && typeof parsed.data.message === "string"){
            enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
        }
        setDialogError((parsed.data) ? parsed.data.message : {})
    }
 //   setUpdateCount((prev) => prev + 1)
    getData();
    cleardata();
  }
const cleardata=()=>{
setRtype_Id(0)
setRtype_Name('')
}
    const sendUpdate=async () =>{
     //   let uparams = new URLSearchParams();
        let formdata = new FormData();
        formdata.append("Rtype_Id", Rtype_Id);
        formdata.append("Rtype_Name", Rtype_Name);
        let response;
    
        
        if (Rtype_Id>0)
        {
            response = await PostDataPromise(apiMain + "/api/v1/roomtype/update", formdata);
           let parsed = JSON.parse(response);
        }
        else{
            response = await PostDataPromise(apiMain + "/api/v1/roomtype/insert", formdata);
            let parsed = JSON.parse(response);
         }
         getData()
    }
    const handleRowClick = (params) => {
        localStorage.setItem('Rtype_Id', params.row.Rtype_Id)
        setRtype_Id(params.row.Rtype_Id)
        setRtype_Name(params.row.Rtype_Name)
        

    };
    const onNewAgency =()=>{
        setRtype_Id(0)
        setRtype_Name('')
    }

    return (
        <div  >
            <Box className="CheckIn" style={{ textAlign: 'left',marginTop:'15px', width: '500px', height: '40px' }}
                component="form"
                sx={{ '& > :not(style)': { m: 1 } }}
                noValidate
                autoComplete="off"
            >

                <div style={{ textAlign: 'left',   float: 'left' }}>
                <label for="" style={{fontSize:'12px'}}> Id </label>
                    <input
                        type="text"
                        id="Rtype_Id"
                        disabled={true}
                        value={Rtype_Id}
                        onChange={(e) =>
                            setRtype_Id(e.target.value)
                        }
                        // //placeholder="Enter First Name"
                        required
                        style={{width:'60px'}}
                    />
           
           
                {/* <div style={{ position: 'flex',marginLeft:'30px', float: 'left', marginTop: '5px', lineHeight: '.1' }}> */}
                <label for="" style={{marginLeft:'10px',fontSize:'12px'}}>Room Type* </label>

                    <input
                        type="text"
                        id="Prese_Name"
                        disabled={false}
                        value={Rtype_Name}
                        onChange={(e) =>
                            setRtype_Name(e.target.value)
                        }
                        // //placeholder="Enter First Name"
                        required
                        style={{width:'230px'}}
                    />
           
            {/* <div style={{display:'flex',float:'left',marginTop:'-10px'}}>
                <Stack direction="row" spacing={1} style={{paddingLeft:'10px',marginTop:'0px'}}>
                        <Chip label="New" onClick={onNewAgency} color="primary" disabled={!NewFlag} sx={{width:80 ,cursor:'pointer'}} />
                        <Chip label="Add" onClick={sendAdd} color="primary" disabled={!Addflag} sx={{width:80 ,cursor:'pointer'}} />
                        <Chip label="Edit" onClick={sendUpdate} color="primary" disabled={!EditFlag} sx={{width:80 ,cursor:'pointer'}} />
                        <Chip label="Delete" onClick={sendDelete} color="error" disabled={!DelFlag} sx={{width:80 , cursor:'pointer'}} />
               </Stack>
      </div> */}
      </div>
            </Box>
            {/* <div class style={{ float: 'left' }}>
                <Button sx={{ backgroundColor: "#EDD682", color: "black", width: "170px", marginLeft: '80px', cursor: 'pointer', ":hover": { backgroundColor: "#EDD682", color: "#000000" } }}
                    type="submit"
                    value="Submit"
                    onClick={()=>sendUpdate()}
                >
                    confirm
                </Button>
                <Button sx={{ backgroundColor: "#2C2C2C", color: '#ffffff', width: "170px", marginLeft: '15px', transition: '0.7s', ':hover': { backgroundColor: "#EDD682", color: "#000000" } }}
                    type="submit"
                    value="Submit"
                  onClick={() => onNewAgency()}

                >
                    New
                </Button>
            </div> */}
            <Box className="CheckIn" style={{ textAlign: 'left', width: '500px',height:'200px', marginTop: '5px' }}
                component="form"
                sx={{ '& > :not(style)': { m: 1 } }}
                noValidate
                autoComplete="off"
            >

                <div style={{ textAlign: 'left', marginTop: '5px', lineHeight: '.1' }}>
                    <Paper sx={{ height: '200px', width: '100%' }}>
                        <StripedDataGrid onRowClick={handleRowClick}
                            rows={Data}
                            columns={columns}
                            getRowId={() => crypto.randomUUID()}
                            initialState={{ pagination: { paginationModel } }}
                            pageSizeOptions={[5, 10]}
                            //checkboxSelection
                            sx={{ border: 0, fontFamily: 'Roboto', fontWeight: 'normal', fontSize: '12px' }}
                            // onSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
                            getRowClassName={(params) =>
                                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                            }
                        />
                    </Paper>
                </div>
            </Box>

        </div>
    )
})
export default Room_Types;